import {createSlice, createAsyncThunk} from "@reduxjs/toolkit";
import api from "../../utils/api";
import {format, addDays, subDays} from "date-fns";
import {toast} from "react-toastify";
import {buildQueryString} from "../../utils/buildQueryString";

const WiseBerryAPIEnv = process.env.VITE_API_KEY;

export const getIndividualResults = createAsyncThunk(
  "oneonone/getIndividualResults",
  async (obj, {rejectWithValue}) => {
    try {
      let queryString = buildQueryString(obj);

      const res = await api.get(
        `${WiseBerryAPIEnv}member/organisation-results?${queryString}`
      );
      return res.data.data;
    } catch (err) {
      if (err.response && err.response.status === 401) {
        toast.error("Please Login, Authorization Denied");
      }
      return rejectWithValue(err.message);
    }
  }
);

export const postSetTarget = createAsyncThunk(
  "oneonone/setTarget",
  async (obj, {rejectWithValue}) => {
    try {
      // debugger;
      let queryString = buildQueryString(obj);

      const res = await api.post(
        `${WiseBerryAPIEnv}member/individual-results`,
        obj,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      toast.success("Target Updated Successfully");
      return res.data.data;
    } catch (err) {
      if (err.response && err.response.status === 401) {
        toast.error("Please Login, Authorization Denied");
      }
      return rejectWithValue(err.message);
    }
  }
);

// https://api.wiseberryonline.com.au/api/v1/member/individual-results

let initialState = {
  individualResults: {},
  addTarget: {},
  loadingAddTarget: false,
  addTargetError: null,
  loading: false,
  individualResultsError: null,
};

const oneOnoneSlice = createSlice({
  name: "oneOnone",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getIndividualResults.pending, (state) => {
        state.loading = true;
      })
      .addCase(getIndividualResults.fulfilled, (state, action) => {
        state.individualResults = action.payload;
        state.loading = false;
        state.individualResultsError = null;
      })
      .addCase(getIndividualResults.rejected, (state, action) => {
        state.loading = false;
        state.individualResultsError = action.payload;
        state.individualResults = {};
      });
  },
});

export default oneOnoneSlice?.reducer;
